if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();

      if (this.classList.contains('disabled')) return;

      this.cartDrawer = document.querySelector('cart-drawer');
      this.defaultMedia = this.querySelector('.js-media-default');

      // Direct size buttons
      this.directSizeBtns = this.querySelectorAll('.js-btn-size');
      this.directSizeBtns.forEach(btn =>
        btn.addEventListener('click', this.handleBtnSizeClick.bind(this))
      );

      // Swatches
      this.swatches = this.querySelector('.js-swatches');
      if (this.swatches) {
        this.btnSwatches = this.swatches.querySelectorAll('.js-btn-swatch');

        this.swatches.addEventListener('change', async e => {
          const btnSwatch = e.target;
          if (!btnSwatch.classList.contains('js-btn-swatch')) return;

          const color = btnSwatch.dataset.color;
          const slug = color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          const active = this.swatches.querySelector('.js-btn-swatch.is-active');
          const currentMedia = this.querySelector('.js-media-default.is-visible');
          const newMedia = this.querySelector(`.js-media-${slug}`);

          active?.classList.remove('is-active');
          btnSwatch.classList.add('is-active');
          currentMedia?.classList.remove('is-visible');
          newMedia?.classList.add('is-visible');

          this.querySelector('a.card-product__media')?.classList.remove('is-transitioning');
        });
      }
    }

    async handleBtnSizeClick(e) {
      e.preventDefault();
      const button = e.currentTarget;
      const btnText = button.querySelector('.js-btn-text');
      const btnLoader = button.querySelector('.js-btn-loader');

      if (this.classList.contains('is-requesting')) return;
      this.toggleBtns();

      // Show loader
      btnText?.classList.add('visually-hidden');
      btnLoader?.classList.remove('visually-hidden');

      const variantId = button.dataset.variantid;
      const config = fetchConfig('javascript');
      const formData = new FormData();

      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('sections', this.cartDrawer?.getSectionsToRender()?.map(s => s.section));
      formData.append('sections_url', window.location.pathname);

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      try {
        const res = await fetch(`${routes.cart_add_url}`, config);
        const data = await res.json();

        if (!res.ok) throw new Error(data.description || 'Failed to add to cart');

        await updateCartBadge();
        this.showToast("Product added to cart");
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        }, 100);

        // Optional: open cart drawer
        // this.cartDrawer.renderContents(data, true);

      } catch (err) {
        console.error('Add to cart error:', err);
      } finally {
        // Reset loader
        btnText?.classList.remove('visually-hidden');
        btnLoader?.classList.add('visually-hidden');
        this.toggleBtns();
      }
    }

    toggleBtns() {
      this.classList.toggle('is-requesting');
      this.btnSwatches?.forEach(btn => btn.toggleAttribute('disabled'));
    }

    async getProduct() {
      try {
        const res = await fetch(`${window.Shopify.routes.root}products/${this.dataset.handle}.js`);
        return await res.json();
      } catch (err) {
        console.error('Failed to fetch product JSON:', err);
      }
    }

    showToast(message = "Added to cart") {
  let toast = document.createElement('div');
  toast.className = 'cart-toast';
  toast.textContent = message;

  document.body.appendChild(toast);

  setTimeout(() => {
    toast.classList.add('visible');
  }, 10);

  setTimeout(() => {
    toast.classList.remove('visible');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

  }

  customElements.define('card-product', CardProduct);
}

// ✅ Safe global cart badge updater
if (typeof updateCartBadge === 'undefined') {
  var updateCartBadge = async () => {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await res.json();
      const badge = document.querySelector('.cart-count-badge');

      if (!badge) return;

      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'block' : 'none';
    } catch (err) {
      console.error('Failed to update cart badge:', err);
    }
  };
}
